import { render } from "./Footer.vue?vue&type=template&id=d890c2e8"
const script = {}

import exportComponent from "C:\\Users\\DEV-HMP\\Documents\\TPM_Site\\Vendor\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__